import Colors from '@omni/kit/theming/Colors';
import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import LeftNavButton, { LeftNavType } from '../components/LeftNavButton';

const navStyles = StyleSheet.create({
  headerTitleStyle: {
    color: Colors.N900,
    fontSize: 16,
    fontWeight: '600',
  },
});

export const getNavOptions = (
  title: string,
  { navigation }: { navigation: { goBack: () => void } },
  type?: LeftNavType,
  onBackPress?: () => void
): {
  title: string;
  headerTitleStyle: { color: string; fontSize: number; fontWeight: string };
  headerTintColor: string;
  headerLeft?: () => React.ReactElement;
} => ({
  title,
  headerTitleStyle: navStyles.headerTitleStyle,
  headerTintColor: Colors.N900,
  ...Platform.select({
    default: {
      headerLeft: () => (
        <LeftNavButton
          type={type ?? LeftNavType.Back}
          title={title}
          onPress={onBackPress || navigation.goBack}
        />
      ),
    },
    android: null,
  }),
});
